import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import SearchableSelect from "util/component/SearchableSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import axios from "util/axios";

import { useTranslation } from "react-i18next";

import ModalPortal from "util/component/Modal";
import { Confirm, Modal } from "util/component/Modal/Modal";

import { useDispatch, useSelector } from "react-redux";

import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { CKEditorOptions } from "util";
import { PreviewContainer } from "util/component/CKEditorPreview";

const EditList = ["descHeader", "descCommon", "descFooter"];

const DescTemp = () => {
    const loadingSelector = useSelector((store) => store.loading);
    const dispatch = useDispatch();
    const userSelector = useSelector((store) => store.user);
    const reactQuillRef = useRef([]);
    const { t } = useTranslation(["page"]);

    const [ConfirmOpen, SetConfirmOpen] = useState(false);
    const [ModalOpen, SetModalOpen] = useState(false);

    const [data, setData] = useState(null);

    const [PreviewOpen, SetPreviewOpen] = useState(null);


    const [inputs, setInputs] = useState({
        processCd: "",
    });
    const procList = [
        { label: "USP", value: "USP" },
        { label: "DSP", value: "DSP" },
    ];

    const getDesc = useCallback(async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsDesc/retrieveDescTemplate",
                inputs
            );
            const result = response.data.data.result;
            setData(result);
        } catch (e) {
            console.error(e);
        }
        dispatch({ type: "LOADING_OFF" });
    },[dispatch, inputs]);

    useEffect(() => {
        if(inputs.processCd) {
            getDesc();
        }
    }, [getDesc, inputs.processCd]);

    const confirmValid = () => {
        let valid = true;
        const el = document.getElementById("saveMsg");

        valid = !!el.value;
        if (!valid) {
            document.getElementById("mainFormSaveSpan").classList.remove("valid");
        }
        return valid;
    };

    const handleConfirmValid = () => {
        document.getElementById("mainFormSaveSpan").classList.add("valid");
    };

    const onConfirm = (close) => {
        let valid = confirmValid();

        if (valid) {
            const el = document.getElementById("saveMsg");
            close(false);
            SaveFormData({ msg: el.value });
        }
    };

    const HandleTempSaveOpen = () => {
        SetModalOpen(!ModalOpen);
    };

    const SaveFormData = async ({ msg }) => {
        let formData = {};
        EditList.forEach((v, i) => {
            formData = { ...formData, [v]: reactQuillRef.current[i].getData() };
        });
        formData = {
            ...data,
            ...formData,
            ...inputs,
            userId: userSelector.userId,
            memo: msg,
            message: msg
        };
        dispatch({ type: "LOADING_ON" });
        try {
            const response = await axios.post(
                        process.env.REACT_APP_API + "/pcsDesc/modifyDescTemplate",
                        formData
                    );
                    SetModalOpen(true);
        } catch (e) {
            console.error(e);
        }
        getDesc();
    };
    // Preview
    const PreviewHandler = (index) => {
        const html = reactQuillRef.current[index].getData();
        SetPreviewOpen(html);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
    const HandleSetPreviewOpen = () => {
        SetPreviewOpen(null);
    }


    const renderPage = useMemo(() => {
        return EditList.map((v, i) => {
            return (
                <div key={"ItemPage" + i} className={"ItemPage"}>
                    <div className="d-flex align-center gap-20">
                        <h1
                            onClick={(e) => {
                                e.target.closest(".ItemPage").classList.toggle("hide");
                            }}
                        >
                            Description {v.replace("desc", "")} <FontAwesomeIcon icon={faAngleUp} />
                        </h1>
                        <button className={"bpl-btn success"} onClick={() => {PreviewHandler(i)}}>{t("preview")}</button>
                    </div>
                    <div className={"editorbox"}>
                        {!loadingSelector && (
                            <CKEditor
                                editor={Editor}
                                config={CKEditorOptions}
                                watchdogConfig={{ crashNumberLimit: 10 }}
                                onReady={(editor) => {
                                    window.editor = editor;
                                    editor.setData(data?.[v] || "");
                                    reactQuillRef.current[i] = editor;
                                }}
                             
                            />
                        )}
                    </div>
                </div>
            );
        });
    }, [data, loadingSelector]);

    return (
        <>
            <div className="bpl-container" style={{ paddingBottom: "300px" }}>
                <section className="maindesc">
                    <ul className="nav">
                        <li>
                            <p>Process</p>
                            <SearchableSelect
                                name="process"
                                value={inputs.processCd}
                                search={true}
                                options={procList}
                                border={"ON"}
                                onChange={(val) => {
                                    setInputs((t) => ({
                                        ...t,
                                        processCd: val.value,
                                    }));
                                }}
                            />
                        </li>
                        <li>
                            {data && (
                                <div className="btnbox">
                                    <button
                                        className="btn btn-success"
                                        onClick={() => SetConfirmOpen(true)}
                                    >
                                        {t("save")}
                                    </button>
                                </div>
                            )}
                        </li>
                    </ul>

                    <div className="content">{data && renderPage}</div>
                    {PreviewOpen !== null && <PreviewContainer onClose={HandleSetPreviewOpen}>{PreviewOpen}</PreviewContainer>}
                </section>
            </div>

            {ConfirmOpen && (
                <ModalPortal>
                    <Confirm
                        onClose={() => SetConfirmOpen(false)}
                        valid={confirmValid}
                        onConfirm={() => onConfirm(SetConfirmOpen)}
                        autoComplete={false}
                    >
                        <p>
                            {t("saveConfirm")}
                            <br />
                            {t("saveConfirm2")}
                        </p>
                        <textarea id="saveMsg" defaultValue="" onFocus={handleConfirmValid} />
                        <span id="mainFormSaveSpan" className={"valid"}>
                            {t("noReason")}
                        </span>
                    </Confirm>
                </ModalPortal>
            )}
            {ModalOpen && (
                <ModalPortal>
                    <Modal onClose={HandleTempSaveOpen}>{t("saved")}</Modal>
                </ModalPortal>
            )}
        </>
    );
};

export default React.forwardRef(DescTemp);
